import { render } from "./CardsPage.vue?vue&type=template&id=8ecf5dc8&ts=true"
import script from "./CardsPage.vue?vue&type=script&lang=ts"
export * from "./CardsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__